import { E_ENQUIRY_LOG_TYPE } from "../enums/EnquiryLogTypes";
import { ICEAInfo } from "./CEAInfo";
import { Device } from "./LoginActivity";
import { IProjectLocale } from "./Project";
import { IRequestPagination } from "./requests";
import { IUserData } from "./Users";

export enum EEnquiryEntryContactStatus {
  NEW = "new",
  OPEN = "open",
  IN_PROGRESS = "in-progress",
  UNQUALIFIED = "unqualified",
  ATTEMPTED_TO_CONTACT = "attempted-to-contact",
  CONNECTED = "connected",
}

export enum ESubmitFrom {
  LISTING_PAGE = "listing_page",
  LANDING_PAGE = "landing_page",
}

export enum EActionTrackingType {
  UPDATE_CONTACT_STATUS = "updateContactStatus",
  VIEW_DETAIL = "viewDetail",
  CLICK_CONTACT_WHATSAPP_BUTTON = "clickContactWhatsappButton",
}

export enum EContactSaleSubmissionTag {
  HOT_LEAD = "hot-lead",
  AGENT_LEAD = "agent-lead",
  DUPLICATED_LEAD = "duplicated-lead",
}
export type LeadFeedbackStatus = "good" | "bad";

export enum EOTPStatus {
  PENDING = "pending",
  VERIFIED = "verified",
  UNVERIFIED = "unverified",
}

export interface IEnquiryEntry {
  id: string;
  verificationStatus: EOTPStatus;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
  interestedIn: string;
  phone: string;
  name: string;
  email: string;
  appointment: string | Date | number;
  unitTypes: string;
  project: IProjectLocale;
  user: IUserData;
  tracking: string;
  ceaInfo: ICEAInfo;
  ip: string | null;
  country: string | null;
  device: Device | null;
  browser: string | null;
  score: number;
  contactStatus?: EEnquiryEntryContactStatus;
  note?: string;
  adminNote?: string;
  submitFrom?: string | null;
  leadSource?: string | null;
  feedbackStatus?: LeadFeedbackStatus;
  tags?: EContactSaleSubmissionTag[];
  gclid?: string;
  submittedFromDomain?: string;
  isEcbAgent?: boolean;
  contactSaleSubmissionReportId?: string;
  contactSaleSubmissionReport?: ContactSaleSubmissionReport;
  searchTerm?: string | null;
  recentlyContacted?: {
    days: number;
    uniqueUsers: number;
  };
  timesEnquired?: number;
  gbraid?: string;
  wbraid?: string;
  campaignId?: string;
  customField?: string;
  assignedTo?: IUserAssignedTo;
}

export interface IEnquiryEntryLogAction {
  id: string;
  actionTrackingType: EActionTrackingType;
  user?: null | IUserData; // If user deleted, it will be null
  submissionId?: string;
  userId?: string;
  content?: string;

  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
}

export interface IEnquiryEntryUpdateDTO {
  contactStatus?: EEnquiryEntryContactStatus;
  note?: string;
}

export interface IEnquirySubmissionLog {
  id: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  type: E_ENQUIRY_LOG_TYPE;
  point: number;
  reason: string;
}

export interface IActionLogQuery extends IRequestPagination {
  submissionId?: string;
  sort?: Record<string, "desc" | "asc">;
  search?: Record<string, string>;
}

export interface ICeaDetails {
  id: string;
  name: string;
  businessName: string;
  licenseNumber: string;
  validityDateStart: string;
  validityDateEnd: string;
  awards: string[];
  disciplinaryActions: string[];
  registrationNumber: string;
  photoUrl: string;
  currentEa: string;
}

export interface ContactSaleSubmissionReport {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  rawReportID: number;
  emails: string[];
  phones: string[];
  alias: string[];
  description: string;
  reportID: string;
  lastSubmissionAt: string;
}

export interface IUserAssignedTo {
  id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  status: string;
  role: string;
  firstName: string;
  lastName: string;
  phone: string;
  whatsapp: string | null;
  photoId: string | null;
  agencyLogoId: string | null;
  company: string | null;
  ownerId: string;
  isFlowSignUp: boolean;
}
